module.exports = __webpack_public_path__ + "static/774fb7f8a13836cfc1796a132d5a57020fb8c9c2a0e8d6062345185b059d27fc-8b37262ea1985b1269e872d9efac3d03.png";